import { useState, useCallback } from 'react';
import { CONNECTIONS } from '../data/connections';
function shuffle(a){const b=[...a];for(let i=b.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[b[i],b[j]]=[b[j],b[i]];}return b;}
export default function Connections({onBack,best,setBest}){
  const [phase,setPhase]=useState('home');
  const [puzzle,setPuzzle]=useState(null);
  const [items,setItems]=useState([]);
  const [sel,setSel]=useState([]);
  const [solved,setSolved]=useState([]);
  const [mistakes,setMistakes]=useState(0);
  const [shake,setShake]=useState(false);
  const [msg,setMsg]=useState('');
  const MAX_MISTAKES=4;
  const start=useCallback(()=>{
    const p=CONNECTIONS[Math.floor(Math.random()*CONNECTIONS.length)];
    setPuzzle(p);
    const all=shuffle(p.groups.flatMap(g=>g.items.map(item=>({item,groupLabel:g.label,colour:g.colour}))));
    setItems(all);setSel([]);setSolved([]);setMistakes(0);setMsg('');setPhase('play');
  },[]);
  const toggle=useCallback((item)=>{
    if(solved.some(s=>s.items.includes(item)))return;
    setSel(prev=>prev.includes(item)?prev.filter(x=>x!==item):[...prev,item].slice(0,4));
  },[solved]);
  const submit=useCallback(()=>{
    if(sel.length!==4)return;
    const p=puzzle;
    const match=p.groups.find(g=>g.items.every(i=>sel.includes(i))&&sel.every(i=>g.items.includes(i)));
    if(match){
      setSolved(prev=>[...prev,match]);setSel([]);
      if(solved.length+1===p.groups.length){
        const sc=MAX_MISTAKES-mistakes;if(sc>best)setBest(sc);setPhase('over');
      }
    } else {
      setMistakes(m=>m+1);setShake(true);setTimeout(()=>setShake(false),450);
      const oneAway=p.groups.some(g=>{const overlap=sel.filter(i=>g.items.includes(i));return overlap.length===3;});
      setMsg(oneAway?'One away!':'Not quite...');setTimeout(()=>setMsg(''),1800);
      if(mistakes+1>=MAX_MISTAKES){setPhase('over');}
    }
  },[sel,puzzle,solved,mistakes,best,setBest]);
  const solvedLabels=solved.map(g=>g.label);
  const remaining=puzzle?puzzle.groups.filter(g=>!solvedLabels.includes(g.label)):[];
  return(<div className="layer" style={{display:'flex',flexDirection:'column',minHeight:'100vh'}}>
    <div className="g-hdr">
      <button className="g-back" onClick={onBack}>← Menu</button>
      <div className="g-title" style={{color:'#a78bfa'}}>WC CONNECTIONS</div>
      {phase==='play'&&<div className="g-pills">
        <div className="g-pill" style={{borderColor:'#7c3aed'}}><span className="g-plbl">Mistakes</span><span className="g-pval">{mistakes}/{MAX_MISTAKES}</span></div>
        <div className="g-pill"><span className="g-plbl">Best</span><span className="g-pval">{best}</span></div>
      </div>}
    </div>
    {phase==='home'&&<div className="game-home"><div className="game-inner">
      <div className="game-eye" style={{color:'#a78bfa',border:'1px solid #7c3aed'}}>NYT-Style · World Cup Edition</div>
      <h1 className="game-big" style={{color:'#a78bfa'}}>CONNECTIONS</h1>
      <p className="game-desc">Find 4 groups of 4 items that share a World Cup connection.<br/>You have <strong>4 mistakes</strong> allowed.</p>
      {best>0&&<p className="game-best" style={{color:'#a78bfa'}}>Best score: {best}</p>}
      <button className="btn-purple" style={{marginTop:8}} onClick={start}>NEW PUZZLE</button>
    </div></div>}
    {phase==='over'&&<div className="game-home"><div className="over-card">
      <div className="over-tag" style={{color:'#a78bfa',border:'1px solid #7c3aed'}}>{mistakes>=MAX_MISTAKES?'GAME OVER':'SOLVED!'}</div>
      <h1 className="over-h1">{mistakes>=MAX_MISTAKES?'Better luck next time':'Nice work!'}</h1>
      <div className="over-stats">
        <div className="over-stat"><span className="over-num" style={{color:'#a78bfa'}}>{solved.length}</span><span className="over-lbl">Solved</span></div>
        <div className="over-div"/>
        <div className="over-stat"><span className="over-num" style={{color:'#ef4444'}}>{mistakes}</span><span className="over-lbl">Mistakes</span></div>
        <div className="over-div"/>
        <div className="over-stat"><span className="over-num" style={{color:'#a78bfa'}}>{best}</span><span className="over-lbl">Best</span></div>
      </div>
      {puzzle&&<div style={{display:'flex',flexDirection:'column',gap:6,width:'100%'}}>
        {puzzle.groups.map((g,i)=><div key={i} className="conn-solved-row" style={{background:g.colour+'22',border:'2px solid '+g.colour}}>
          <div className="conn-solved-label" style={{color:g.colour}}>{g.label}</div>
          <div className="conn-solved-items">{g.items.join(' · ')}</div>
        </div>)}
      </div>}
      <button className="btn-purple" onClick={start}>NEW PUZZLE</button>
    </div></div>}
    {phase==='play'&&puzzle&&<div className="game-body">
      <p style={{textAlign:'center',fontSize:'0.8rem',color:'#8ba3cc',fontWeight:600}}>{puzzle.title} — find the 4 groups</p>
      {solved.map((g,i)=><div key={i} className="conn-solved-row" style={{background:g.colour+'22',border:'2px solid '+g.colour}}>
        <div className="conn-solved-label" style={{color:g.colour}}>{g.label}</div>
        <div className="conn-solved-items">{g.items.join(' · ')}</div>
      </div>)}
      <div className={'conn-grid'+(shake?' conn-shake':'')}>
        {items.filter(({item})=>!solved.some(s=>s.items.includes(item))).map(({item,colour},i)=>(
          <button key={i} className={'conn-item'+(sel.includes(item)?' selected':'')} onClick={()=>toggle(item)}>{item}</button>
        ))}
      </div>
      {msg&&<p style={{textAlign:'center',fontSize:'0.82rem',color:'#f5c518',fontWeight:600,animation:'pop .2s ease'}}>{msg}</p>}
      <div className="conn-mistakes">
        {Array.from({length:MAX_MISTAKES}).map((_,i)=><div key={i} className={'conn-dot '+(i<mistakes?'used':'avail')}/>)}
        <span style={{fontSize:'0.62rem',color:'#4a6a9e',marginLeft:6}}>mistakes remaining: {MAX_MISTAKES-mistakes}</span>
      </div>
      <div className="conn-actions">
        <button className="conn-action" onClick={()=>setSel([])}>Deselect All</button>
        <button className="conn-action" onClick={()=>setItems(shuffle([...items]))}>Shuffle</button>
        <button className="conn-action" style={{borderColor:sel.length===4?'#a78bfa':'#1e3a6e',color:sel.length===4?'#a78bfa':'#4a6a9e'}} onClick={submit} disabled={sel.length!==4}>Submit</button>
      </div>
    </div>}
  </div>);
}
